import React, { createContext, useCallback, useContext, useState } from "react";
import ToastModal, { ToastType } from "../../components/ui/toast";

interface ToastItem {
    id: number;
    message: string;
    type: ToastType;
}

interface ToastContextType {
    showToastNotify: (message: string, type: ToastType) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export function ToastProvider({ children }: { children: React.ReactNode }) {
    const [toasts, setToasts] = useState<ToastItem[]>([]);

    const showToastNotify = useCallback((message: string, type: ToastType) => {
        const id = Date.now() + Math.random();
        setToasts((prev) => [...prev, { id, message, type }]);
    }, []);

    const handleClose = useCallback((id: number) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    return (
        <ToastContext.Provider value={{ showToastNotify }}>
            {children}
            <div className="pointer-events-none fixed inset-x-3 top-4 z-[9999] flex flex-col items-center gap-3 sm:inset-x-auto sm:right-5 sm:top-5 sm:items-end">
                {toasts.map((toast) => (
                    <div key={toast.id} className="pointer-events-auto w-full max-w-sm">
                        <ToastModal id={toast.id} message={toast.message} type={toast.type} duration={toast.type === "error" || toast.type === "warning" ? 10000 : toast.type === "message" ? 6000 : 4000} onClose={() => handleClose(toast.id)} />
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
}

export function useToastify() {
    const context = useContext(ToastContext);
    if (!context) throw new Error("useToastify must be used inside ToastProvider");
    return context;
}